






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RenderPostModel } from "@/services/render/types";
import { VideoPostProperties, VideoPostCSS } from "@/services/posts/postTypes/video";
import { Style } from "@/services/styles/types";
import VideoSubRender from "@/components/posts/video/VideoSubRender.vue";
import { setNextItem } from "../types";
@Component({
    components: { VideoSubRender }
})
export default class VideoRender extends Vue {
        @Prop() private item!: RenderPostModel;
        @Prop() private active!: number;
        @Prop() private itemStyle!: Style; // it's used only in style form preview
        @Prop() private containerHeight!: number;
        @Prop() private containerWidth!: number;
        @Prop() private numberOfPosts!: number;

        // local
        itemActive = false;
        activeInteger = 0;
        properties = this.item.properties;
        reload = false;

        @Watch("active", { immediate: true, deep: true })
        onActiveChange(value: number) {
            if (value !== 0) {
                this.itemActive = true;
                this.activeInteger++;
            } else {
                this.activeInteger = 0;
            }
        }

        @Watch("item") watchModel() {
            if (JSON.stringify(this.properties) !== JSON.stringify(this.propertiesModel)) {
                this.properties = this.propertiesModel;
                this.reload = !this.reload;
            }
        }

        start() {
            this.itemActive = true;
        }

        triggerDurationIndicator(data: any) {
            this.$emit("triggerDurationIndicator", data);
        }

        triggerPostCountTimer(length: any) {
            this.$emit("triggerPostCountTimer", length);
        }

        // computed
        get propertiesModel(): VideoPostProperties {
            return this.item.properties
                ? (this.item.properties as VideoPostProperties)
                : ({} as VideoPostProperties);
        }

        get styleModel(): VideoPostCSS {
            return this.item.css &&
            Object.entries(this.item.css).length > 0 &&
            this.item.css.constructor === Object
                ? this.item.css as VideoPostCSS
                : this.itemStyle
                    ? this.itemStyle.css as VideoPostCSS
                    : {} as VideoPostCSS;
        }

        // methods

        setNextItem(data: any) {
            this.$emit("setNextItem",
                {
                    id: this.item.id,
                    duration: data.duration,
                    error: data.error
                } as setNextItem);
        }
}
